import { computed, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Resource } from 'app/shared/acl/acl.model';
import { BehaviorSubject } from 'rxjs';

const can = (resources: Partial<Record<Resource, boolean>>, resource: Resource | Resource[] | null | undefined): boolean => {
    if (!resource) {
        // in case no resource is given, return true
        return true;
    }
    if (!Array.isArray(resource)) {
        resource = [resource];
    }
    return resource.some(r => resources[r]);
};

@Injectable({
    providedIn: 'root',
})
export class AclService {

    readonly allowed = new BehaviorSubject<Partial<Record<Resource, boolean>>>({});

    private allowedSignal = toSignal(this.allowed, { requireSync: true });

    makeSignal(resource: Resource | Resource[]) {
        return computed(() => {
            const allowedSignal = this.allowedSignal();
            return can(allowedSignal, resource);
        });
    }

    reset() {
        this.allowed.next({});
    }

    allow(resource: Resource) {
        this.allowed.next({ ...this.allowed.value, [resource]: true });
    }

    configure(resources: Resource[]) {
        this.allowed.next(Object.fromEntries(resources.map(r => [r, true])));
    }

    can(resource: Resource | Resource[] | null | undefined) {
        return can(this.allowed.value, resource);
    }
}
